module.exports = __webpack_public_path__ + "media/country_flags/gd-4664fde4.png";